/* tslint:disable */
import { Observable } from 'rxjs';
import { Injectable, Optional } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent } from '@angular/common/http';

import {
  BaseApiClient,
  RequestContext,
  ApiConfigManager,
  HttpRequestState,
} from '@sg/api/base-api-lib';
import { LegalEntitiesApiConfig } from '../api-config';

import { LegalEntitiesApi } from '../models';

@Injectable()
export class LegalEntitiesGroupApiClient extends BaseApiClient<LegalEntitiesApiConfig> {
  constructor(httpClient: HttpClient, config: ApiConfigManager) {
    super(httpClient, config.legalEntitiesApiConfig);
  }

  legalEntitiesGroupsControllerGetLegalEntitiesGroupTypes(
    xSgUser?: string,

    options?: {
      observe?: 'bodyPromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Promise<Array<string>>;
  legalEntitiesGroupsControllerGetLegalEntitiesGroupTypes(
    xSgUser?: string,

    options?: {
      observe: 'responsePromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Promise<HttpResponse<Array<string>>>;
  legalEntitiesGroupsControllerGetLegalEntitiesGroupTypes(
    xSgUser?: string,

    options?: {
      observe: 'body';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<Array<string>>;
  legalEntitiesGroupsControllerGetLegalEntitiesGroupTypes(
    xSgUser?: string,

    options?: {
      observe: 'bodyWithState';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<HttpRequestState<Array<string>>>;
  legalEntitiesGroupsControllerGetLegalEntitiesGroupTypes(
    xSgUser?: string,

    options?: {
      observe: 'response';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<HttpResponse<Array<string>>>;
  legalEntitiesGroupsControllerGetLegalEntitiesGroupTypes(
    xSgUser?: string,

    options?: {
      observe: 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<HttpEvent<Array<string>>>;
  legalEntitiesGroupsControllerGetLegalEntitiesGroupTypes(
    xSgUser?: string,

    options: {
      observe?:
        | 'responsePromise'
        | 'bodyPromise'
        | 'response'
        | 'body'
        | 'bodyWithState'
        | 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    } = {},
  ): Promise<any> | Observable<any> {
    const requestContext: RequestContext = {};

    requestContext.headers = this.createHeaders(options.headers || {}, ['x-sg-user', xSgUser]);

    this.setAcceptHeader(requestContext, 'application/json');

    this.setApiKeySecurity('Authorization', 'header', requestContext);

    const baseOptions = this.createClientOptions(requestContext, options);
    const obs$ = this.httpClient.get<Array<string>>(
      `${this.basePath}/gateway/admin/legal-entities-groups/types`,
      <any>Object.assign(baseOptions, {}),
    );

    if (options.observe === 'bodyWithState') {
      return this.toHttpRequestState(obs$);
    }

    return !options.observe || options.observe.endsWith('Promise') ? this.toPromise(obs$) : obs$;
  }

  legalEntitiesGroupsControllerGetLegalEntityGroupById(
    params: { xSgUser?: string; id: string },
    options?: {
      observe?: 'bodyPromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Promise<LegalEntitiesApi.LegalEntitiesGroupDto>;
  legalEntitiesGroupsControllerGetLegalEntityGroupById(
    params: { xSgUser?: string; id: string },
    options?: {
      observe: 'responsePromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Promise<HttpResponse<LegalEntitiesApi.LegalEntitiesGroupDto>>;
  legalEntitiesGroupsControllerGetLegalEntityGroupById(
    params: { xSgUser?: string; id: string },
    options?: {
      observe: 'body';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<LegalEntitiesApi.LegalEntitiesGroupDto>;
  legalEntitiesGroupsControllerGetLegalEntityGroupById(
    params: { xSgUser?: string; id: string },
    options?: {
      observe: 'bodyWithState';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<HttpRequestState<LegalEntitiesApi.LegalEntitiesGroupDto>>;
  legalEntitiesGroupsControllerGetLegalEntityGroupById(
    params: { xSgUser?: string; id: string },
    options?: {
      observe: 'response';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<HttpResponse<LegalEntitiesApi.LegalEntitiesGroupDto>>;
  legalEntitiesGroupsControllerGetLegalEntityGroupById(
    params: { xSgUser?: string; id: string },
    options?: {
      observe: 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<HttpEvent<LegalEntitiesApi.LegalEntitiesGroupDto>>;
  legalEntitiesGroupsControllerGetLegalEntityGroupById(
    params: { xSgUser?: string; id: string },
    options: {
      observe?:
        | 'responsePromise'
        | 'bodyPromise'
        | 'response'
        | 'body'
        | 'bodyWithState'
        | 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    } = {},
  ): Promise<any> | Observable<any> {
    const requestContext: RequestContext = {};

    this.verifyRequired(['id', params.id]);

    requestContext.headers = this.createHeaders(options.headers || {}, [
      'x-sg-user',
      params.xSgUser,
    ]);

    this.setAcceptHeader(requestContext, 'application/json');

    this.setApiKeySecurity('Authorization', 'header', requestContext);

    const baseOptions = this.createClientOptions(requestContext, options);
    const obs$ = this.httpClient.get<LegalEntitiesApi.LegalEntitiesGroupDto>(
      `${this.basePath}/gateway/admin/legal-entities-groups/${this.encodeURI(String(params.id))}`,
      <any>Object.assign(baseOptions, {}),
    );

    if (options.observe === 'bodyWithState') {
      return this.toHttpRequestState(obs$);
    }

    return !options.observe || options.observe.endsWith('Promise') ? this.toPromise(obs$) : obs$;
  }

  legalEntitiesGroupsControllerUpdateLegalEntityGroupById(
    params: {
      body?: LegalEntitiesApi.UpdateLegalEntitiesGroupRequest;
      xSgUser?: string;
      idempotencykey?: string;
      id: string;
    },
    options?: {
      observe?: 'bodyPromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Promise<LegalEntitiesApi.LegalEntitiesGroupDto>;
  legalEntitiesGroupsControllerUpdateLegalEntityGroupById(
    params: {
      body?: LegalEntitiesApi.UpdateLegalEntitiesGroupRequest;
      xSgUser?: string;
      idempotencykey?: string;
      id: string;
    },
    options?: {
      observe: 'responsePromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Promise<HttpResponse<LegalEntitiesApi.LegalEntitiesGroupDto>>;
  legalEntitiesGroupsControllerUpdateLegalEntityGroupById(
    params: {
      body?: LegalEntitiesApi.UpdateLegalEntitiesGroupRequest;
      xSgUser?: string;
      idempotencykey?: string;
      id: string;
    },
    options?: {
      observe: 'body';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<LegalEntitiesApi.LegalEntitiesGroupDto>;
  legalEntitiesGroupsControllerUpdateLegalEntityGroupById(
    params: {
      body?: LegalEntitiesApi.UpdateLegalEntitiesGroupRequest;
      xSgUser?: string;
      idempotencykey?: string;
      id: string;
    },
    options?: {
      observe: 'bodyWithState';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<HttpRequestState<LegalEntitiesApi.LegalEntitiesGroupDto>>;
  legalEntitiesGroupsControllerUpdateLegalEntityGroupById(
    params: {
      body?: LegalEntitiesApi.UpdateLegalEntitiesGroupRequest;
      xSgUser?: string;
      idempotencykey?: string;
      id: string;
    },
    options?: {
      observe: 'response';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<HttpResponse<LegalEntitiesApi.LegalEntitiesGroupDto>>;
  legalEntitiesGroupsControllerUpdateLegalEntityGroupById(
    params: {
      body?: LegalEntitiesApi.UpdateLegalEntitiesGroupRequest;
      xSgUser?: string;
      idempotencykey?: string;
      id: string;
    },
    options?: {
      observe: 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<HttpEvent<LegalEntitiesApi.LegalEntitiesGroupDto>>;
  legalEntitiesGroupsControllerUpdateLegalEntityGroupById(
    params: {
      body?: LegalEntitiesApi.UpdateLegalEntitiesGroupRequest;
      xSgUser?: string;
      idempotencykey?: string;
      id: string;
    },
    options: {
      observe?:
        | 'responsePromise'
        | 'bodyPromise'
        | 'response'
        | 'body'
        | 'bodyWithState'
        | 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    } = {},
  ): Promise<any> | Observable<any> {
    const requestContext: RequestContext = {};

    this.verifyRequired(['id', params.id]);

    const consumes = ['application/json'];

    requestContext.headers = this.createHeaders(
      options.headers || {},
      ['x-sg-user', params.xSgUser],
      ['idempotencykey', params.idempotencykey],
    );

    this.setAcceptHeader(requestContext, 'application/json');

    this.setContentTypeHeader(requestContext, ...consumes);

    this.setApiKeySecurity('Authorization', 'header', requestContext);

    const baseOptions = this.createClientOptions(requestContext, options);
    const obs$ = this.httpClient.put<LegalEntitiesApi.LegalEntitiesGroupDto>(
      `${this.basePath}/gateway/admin/legal-entities-groups/${this.encodeURI(String(params.id))}`,
      params.body,
      <any>Object.assign(baseOptions, {}),
    );

    if (options.observe === 'bodyWithState') {
      return this.toHttpRequestState(obs$);
    }

    return !options.observe || options.observe.endsWith('Promise') ? this.toPromise(obs$) : obs$;
  }

  legalEntitiesGroupsControllerGetLegalEntityGroupBySearchParams(
    params?: {
      body?: LegalEntitiesApi.SearchLegalEntitiesGroupsRequest;
      xSgUser?: string;
      pageSize?: number;
      pageNumber?: number;
      sortDirection?: 'asc' | 'desc';
      orderBy?: 'default';
    },
    options?: {
      observe?: 'bodyPromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Promise<LegalEntitiesApi.LegalEntitiesGroupDtoSearchLegalEntitiesGroupsOrderPagingResultDto>;
  legalEntitiesGroupsControllerGetLegalEntityGroupBySearchParams(
    params?: {
      body?: LegalEntitiesApi.SearchLegalEntitiesGroupsRequest;
      xSgUser?: string;
      pageSize?: number;
      pageNumber?: number;
      sortDirection?: 'asc' | 'desc';
      orderBy?: 'default';
    },
    options?: {
      observe: 'responsePromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Promise<
    HttpResponse<LegalEntitiesApi.LegalEntitiesGroupDtoSearchLegalEntitiesGroupsOrderPagingResultDto>
  >;
  legalEntitiesGroupsControllerGetLegalEntityGroupBySearchParams(
    params?: {
      body?: LegalEntitiesApi.SearchLegalEntitiesGroupsRequest;
      xSgUser?: string;
      pageSize?: number;
      pageNumber?: number;
      sortDirection?: 'asc' | 'desc';
      orderBy?: 'default';
    },
    options?: {
      observe: 'body';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<LegalEntitiesApi.LegalEntitiesGroupDtoSearchLegalEntitiesGroupsOrderPagingResultDto>;
  legalEntitiesGroupsControllerGetLegalEntityGroupBySearchParams(
    params?: {
      body?: LegalEntitiesApi.SearchLegalEntitiesGroupsRequest;
      xSgUser?: string;
      pageSize?: number;
      pageNumber?: number;
      sortDirection?: 'asc' | 'desc';
      orderBy?: 'default';
    },
    options?: {
      observe: 'bodyWithState';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<
    HttpRequestState<LegalEntitiesApi.LegalEntitiesGroupDtoSearchLegalEntitiesGroupsOrderPagingResultDto>
  >;
  legalEntitiesGroupsControllerGetLegalEntityGroupBySearchParams(
    params?: {
      body?: LegalEntitiesApi.SearchLegalEntitiesGroupsRequest;
      xSgUser?: string;
      pageSize?: number;
      pageNumber?: number;
      sortDirection?: 'asc' | 'desc';
      orderBy?: 'default';
    },
    options?: {
      observe: 'response';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<
    HttpResponse<LegalEntitiesApi.LegalEntitiesGroupDtoSearchLegalEntitiesGroupsOrderPagingResultDto>
  >;
  legalEntitiesGroupsControllerGetLegalEntityGroupBySearchParams(
    params?: {
      body?: LegalEntitiesApi.SearchLegalEntitiesGroupsRequest;
      xSgUser?: string;
      pageSize?: number;
      pageNumber?: number;
      sortDirection?: 'asc' | 'desc';
      orderBy?: 'default';
    },
    options?: {
      observe: 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<
    HttpEvent<LegalEntitiesApi.LegalEntitiesGroupDtoSearchLegalEntitiesGroupsOrderPagingResultDto>
  >;
  legalEntitiesGroupsControllerGetLegalEntityGroupBySearchParams(
    params?: {
      body?: LegalEntitiesApi.SearchLegalEntitiesGroupsRequest;
      xSgUser?: string;
      pageSize?: number;
      pageNumber?: number;
      sortDirection?: 'asc' | 'desc';
      orderBy?: 'default';
    },
    options: {
      observe?:
        | 'responsePromise'
        | 'bodyPromise'
        | 'response'
        | 'body'
        | 'bodyWithState'
        | 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    } = {},
  ): Promise<any> | Observable<any> {
    const requestContext: RequestContext = {};

    const consumes = ['application/json'];

    if (params) {
      requestContext.queryParams = this.createQueryParams(
        ['', 'pageSize', params.pageSize],
        ['', 'pageNumber', params.pageNumber],
        ['', 'sortDirection', params.sortDirection],
        ['', 'orderBy', params.orderBy],
      );
    }

    requestContext.headers = this.createHeaders(options.headers || {}, [
      'x-sg-user',
      params?.xSgUser,
    ]);

    this.setAcceptHeader(requestContext, 'application/json');

    this.setContentTypeHeader(requestContext, ...consumes);

    this.setApiKeySecurity('Authorization', 'header', requestContext);

    const baseOptions = this.createClientOptions(requestContext, options);
    const obs$ =
      this.httpClient.post<LegalEntitiesApi.LegalEntitiesGroupDtoSearchLegalEntitiesGroupsOrderPagingResultDto>(
        `${this.basePath}/gateway/admin/legal-entities-groups/search`,
        params?.body,
        <any>Object.assign(baseOptions, {}),
      );

    if (options.observe === 'bodyWithState') {
      return this.toHttpRequestState(obs$);
    }

    return !options.observe || options.observe.endsWith('Promise') ? this.toPromise(obs$) : obs$;
  }

  legalEntitiesGroupsControllerCreateLegalEntityGroup(
    params?: {
      body?: LegalEntitiesApi.CreateLegalEntitiesGroupRequest;
      xSgUser?: string;
      idempotencykey?: string;
    },
    options?: {
      observe?: 'bodyPromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Promise<LegalEntitiesApi.LegalEntitiesGroupDto>;
  legalEntitiesGroupsControllerCreateLegalEntityGroup(
    params?: {
      body?: LegalEntitiesApi.CreateLegalEntitiesGroupRequest;
      xSgUser?: string;
      idempotencykey?: string;
    },
    options?: {
      observe: 'responsePromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Promise<HttpResponse<LegalEntitiesApi.LegalEntitiesGroupDto>>;
  legalEntitiesGroupsControllerCreateLegalEntityGroup(
    params?: {
      body?: LegalEntitiesApi.CreateLegalEntitiesGroupRequest;
      xSgUser?: string;
      idempotencykey?: string;
    },
    options?: {
      observe: 'body';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<LegalEntitiesApi.LegalEntitiesGroupDto>;
  legalEntitiesGroupsControllerCreateLegalEntityGroup(
    params?: {
      body?: LegalEntitiesApi.CreateLegalEntitiesGroupRequest;
      xSgUser?: string;
      idempotencykey?: string;
    },
    options?: {
      observe: 'bodyWithState';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<HttpRequestState<LegalEntitiesApi.LegalEntitiesGroupDto>>;
  legalEntitiesGroupsControllerCreateLegalEntityGroup(
    params?: {
      body?: LegalEntitiesApi.CreateLegalEntitiesGroupRequest;
      xSgUser?: string;
      idempotencykey?: string;
    },
    options?: {
      observe: 'response';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<HttpResponse<LegalEntitiesApi.LegalEntitiesGroupDto>>;
  legalEntitiesGroupsControllerCreateLegalEntityGroup(
    params?: {
      body?: LegalEntitiesApi.CreateLegalEntitiesGroupRequest;
      xSgUser?: string;
      idempotencykey?: string;
    },
    options?: {
      observe: 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<HttpEvent<LegalEntitiesApi.LegalEntitiesGroupDto>>;
  legalEntitiesGroupsControllerCreateLegalEntityGroup(
    params?: {
      body?: LegalEntitiesApi.CreateLegalEntitiesGroupRequest;
      xSgUser?: string;
      idempotencykey?: string;
    },
    options: {
      observe?:
        | 'responsePromise'
        | 'bodyPromise'
        | 'response'
        | 'body'
        | 'bodyWithState'
        | 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    } = {},
  ): Promise<any> | Observable<any> {
    const requestContext: RequestContext = {};

    const consumes = ['application/json'];

    requestContext.headers = this.createHeaders(
      options.headers || {},
      ['x-sg-user', params?.xSgUser],
      ['idempotencykey', params?.idempotencykey],
    );

    this.setAcceptHeader(requestContext, 'application/json');

    this.setContentTypeHeader(requestContext, ...consumes);

    this.setApiKeySecurity('Authorization', 'header', requestContext);

    const baseOptions = this.createClientOptions(requestContext, options);
    const obs$ = this.httpClient.post<LegalEntitiesApi.LegalEntitiesGroupDto>(
      `${this.basePath}/gateway/admin/legal-entities-groups`,
      params?.body,
      <any>Object.assign(baseOptions, {}),
    );

    if (options.observe === 'bodyWithState') {
      return this.toHttpRequestState(obs$);
    }

    return !options.observe || options.observe.endsWith('Promise') ? this.toPromise(obs$) : obs$;
  }
}
